import { Injectable } from '@angular/core';
import {Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication-service';
import { LoadPermissionService } from '../load-permission-service';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable()
export class GuardComponent {
  constructor(public router: Router, 
              public authenticationService: AuthenticationService,
              public loadPermissionService: LoadPermissionService,
              public ngxPermissionsService: NgxPermissionsService
            ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authenticationService.isLoggedIn()) {
      return this.loadPermissionService.loadPermissions().then((permissions) => {
        this.ngxPermissionsService.loadPermissions(permissions);
        return true;
      });
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
